export const PROCTORING_TYPE = {
  LIVE: "live",
  LITE: "lite",
};
